import { WEB_SHOW_DEAL_BANNER } from "../constants";
import getFeatures from "./getFeatures";

const getShowDealBanner = state => {
  const { [WEB_SHOW_DEAL_BANNER]: showDealBanner } = getFeatures(state);

  return !!showDealBanner;
};

export default getShowDealBanner;
